(function () {
  'use strict';
  if (customElements.get('mnb-bike-search')) return;
  class BikeSearch extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.input = this.querySelector('input[type="search"]');
      this.list = this.querySelector('[role="listbox"]');
      this.status = this.querySelector('[role="status"]');
      if (!this.input || !this.list) return;
      this.selected = -1; this.options = []; this.sequence = 0;
      this.listeners = new AbortController();
      const listen = (node, event, fn) => node.addEventListener(event, fn, { signal: this.listeners.signal });
      this.input.setAttribute('aria-controls', this.list.id);
      listen(this.input, 'input', () => this.change());
      listen(this.input, 'compositionstart', () => { this.composing = true; this.dismiss(); });
      listen(this.input, 'compositionend', () => { this.composing = false; this.change(); });
      listen(this.input, 'keydown', event => this.keydown(event));
      listen(this.input, 'blur', () => { this.blurTimer = setTimeout(() => this.dismiss(), 200); });
      listen(this.input, 'focus', () => { clearTimeout(this.blurTimer); if (this.options.length) this.open(); });
      listen(this.list, 'pointerdown', () => clearTimeout(this.blurTimer));
      listen(this.list, 'click', event => { const link = event.target.closest('a[data-option-index]'); if (link) { event.preventDefault(); this.accept(Number(link.dataset.optionIndex)); } });
      listen(this.querySelector('form'), 'submit', event => { if (this.selected >= 0) { event.preventDefault(); this.accept(this.selected); } });
    }
    disconnectedCallback() { this.connected = false; this.listeners?.abort(); this.request?.abort(); clearTimeout(this.timer); clearTimeout(this.blurTimer); clearTimeout(this.timeout); this.sequence++; }
    change() {
      this.dismissed = false; this.sequence++; this.request?.abort(); clearTimeout(this.timer); this.selected = -1; this.options = []; this.list.replaceChildren(); this.close();
      if (!this.composing && this.input.value.trim()) this.timer = setTimeout(() => this.load(this.sequence), 150);
    }
    async load(sequence) {
      const request = this.request = new AbortController(); const timeout = this.timeout = setTimeout(() => request.abort(), 8000);
      this.status.textContent = 'Finding searches…';
      try {
        const base = this.dataset.serviceUrl.replace(/\/$/, '');
        const response = await fetch(base + '/suggest?q=' + encodeURIComponent(this.input.value.trim()), { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const result = await response.json();
        if (sequence !== this.sequence || !this.isConnected) return;
        this.options = (result.suggestions || []).slice(0, 5).filter(s => { try { const url = new URL(s.url, location.origin); return url.origin === location.origin && url.pathname === '/search'; } catch { return false; } });
        this.list.replaceChildren();
        this.options.forEach((option, index) => {
          const row = document.createElement('li'); row.id = this.list.id + '-' + index; row.setAttribute('role', 'option'); row.setAttribute('aria-selected', 'false');
          const link = document.createElement('a'); link.href = option.url; link.tabIndex = -1; link.dataset.optionIndex = index;
          link.textContent = option.label; row.append(link); this.list.append(row);
        });
        this.status.textContent = this.options.length ? this.options.length + ' suggested searches.' : 'No suggestions. Press Enter to search.';
        if (this.options.length && document.activeElement === this.input && !this.dismissed && !this.composing) this.open();
      } catch (error) {
        if (sequence !== this.sequence) return;
        this.status.textContent = 'Suggestions are unavailable. Press Enter to search or type again to retry.';
        this.close();
      } finally { clearTimeout(timeout); }
    }
    dismiss() { this.dismissed = true; this.sequence++; this.request?.abort(); clearTimeout(this.timer); this.close(); }
    open() { this.list.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
    close() { this.list.hidden = true; this.selected = -1; this.input.setAttribute('aria-expanded', 'false'); this.input.removeAttribute('aria-activedescendant'); }
    keydown(event) {
      if (this.composing) return;
      if (event.key === 'Escape' || event.key === 'Tab') { this.dismiss(); return; }
      if (['ArrowDown', 'ArrowUp'].includes(event.key) && this.options.length) {
        event.preventDefault(); this.open();
        this.selected = (this.selected + (event.key === 'ArrowDown' ? 1 : -1) + this.options.length) % this.options.length;
        Array.from(this.list.children).forEach((row, index) => row.setAttribute('aria-selected', String(index === this.selected)));
        this.input.setAttribute('aria-activedescendant', this.list.children[this.selected].id);
      } else if (event.key === 'Enter' && this.selected >= 0) { event.preventDefault(); this.accept(this.selected); }
    }
    accept(index) {
      const option = this.options[index]; if (!option) return;
      const detail = { query: this.input.value.trim(), canonicalQuery: option.label, position: index + 1, url: option.url, surface: this.dataset.surface };
      this.dispatchEvent(new CustomEvent('bike-search-suggestion-select', { bubbles: true, detail }));
      const navigate = new CustomEvent('bike-search-navigate', { bubbles: true, cancelable: true, detail: { url: option.url } });
      if (this.dispatchEvent(navigate)) location.assign(option.url);
    }
  }
  customElements.define('mnb-bike-search', BikeSearch);
})();
